export enum Permission {
  CAN_EDIT_ROOMBOOKINGS = 'CAN_EDIT_ROOMBOOKINGS',
  CAN_APPROVE_ROOMBOOKINGS = 'CAN_APPROVE_ROOMBOOKINGS',
  CAN_REJECT_ROOMBOOKINGS = 'CAN_REJECT_ROOMBOOKINGS',
  CAN_DELETE_ROOMBOOKINGS = 'CAN_DELETE_ROOMBOOKINGS',
  CAN_CANCEL_ROOMBOOKINGS = 'CAN_CANCEL_ROOMBOOKINGS',
  CAN_MANAGE_ROOMBOOKINGS = 'CAN_MANAGE_ROOMBOOKINGS',
  CAN_MANAGE_ROOMS = 'CAN_MANAGE_ROOMS',
  CAN_MANAGE_ROOM_LAYOUTS = 'CAN_MANAGE_ROOM_LAYOUTS',
  CAN_CREATE_USER_GROUP = 'CAN_CREATE_USER_GROUP',
  CAN_MANAGE_USER_GROUP = 'CAN_MANAGE_USER_GROUP',
  CAN_DELETE_USER_GROUP = 'CAN_DELETE_USER_GROUP',
  CAN_MANAGE_CALENDAR = 'CAN_MANAGE_CALENDAR',
  CAN_EDIT_USER_GROUP_USER_LIST = 'CAN_EDIT_USER_GROUP_USER_LIST',
  CAN_EDIT_USER_GROUP_ROOM_LIST = 'CAN_EDIT_USER_GROUP_ROOM_LIST',
  CAN_MANAGE_USER_GROUP_ROLES = 'CAN_MANAGE_USER_GROUP_ROLES',
}

export enum RoleType {
  ROOM_HOST = 'ROOM_HOST',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  ADMIN = 'ADMIN',
}

export enum ServiceProviderType {
  TEM = 'TEM Service',
  LOCKER = 'LOCKER Service',
  FURNITURE = 'Furniture Service',
  CATERING = 'Catering Service',
}
export interface Role {
  id: string;
  roleName: string;
  roleDescription: string;
  roleType: RoleType;
  permissions: Permission[];
}

export interface RoleQueryParams {
  roleName?: string;
  roleType?: RoleType;
}

export interface CreateUpdateRole {
  roleId?: string;
  roleName: string;
  roleDescription: string;
  roleType: RoleType;
  permissions: Permission[];
}
